import { Amount, Reference } from '~/types';
import { ProfileType } from '~/types/profile';

export type Balance = {
  code:
    | 'CURRENT_AVAILABLE'
    | 'CURRENT_UNAVAILABLE'
    | 'CURRENT_PENDING'
    | 'CURRENT_POSTED'
    | 'CURRENT_FLOAT'
    | 'PROCESSED_IN_REALTIME'
    | 'TECHNICAL_OVERDRAFT';
  amount: Amount;
};

export const GL_TYPES = ['AST', 'LIA', 'REV', 'EXP', 'EQT', 'OBS', 'LAS', 'ALS'] as const;
export type GlType = typeof GL_TYPES[number];

export const REGULATORY_TYPES = [
  'DEPOSIT',
  'CASH',
  'EMONEY',
  'LOYALTY',
  'LENDING',
  'SETTLEMENT',
  'POOL',
  'META',
  'EQUITY',
  'SUSPENSE',
] as const;
export type RegulatoryType = typeof REGULATORY_TYPES[number];

export type Account = {
  id: string;
  alias?: string;
  name?: string;
  number: string;
  profileId: string;
  profileType: ProfileType;
  created?: string;
  currency: string;
  currentDay: string;
  balances: Balance[];
  status: 'ACTIVE' | 'BLOCKED' | 'CLOSED';
  productTemplate?: {
    category: 'BUSINESS_CURRENT_ACCOUNT' | string;
    code: 'USD_MERCHANT_CURRENT_ACCOUNT' | 'USD_CONSUMER_CURRENT_ACCOUNT' | string;
    currency: 'USD' | string;
    id: string;
  };
  type?: 'REGULAR' | 'META' | 'SETTLEMENT';
  glType?: GlType;
  regulatoryType?: RegulatoryType;
  branch?: string;
  references?: Reference[];
  bankAccountId?: string;
  description?: string;
  error?: string;
  closed?: string;
};

export type PartnerAccount = {
  productId?: string;
} & Account;

export type ReportedBalance = {
  id: string;
  bankingDay: string;
  accountId: string;
  accountNumber: string;
  profileId: string;
  profileType: ProfileType;
  liquidityBucketId?: string;
  balances: { [x in Balance['code']]: number };
  currency: string;
  reason: string;
  reportedAt: string;
};

export type PnLAccount = {
  id: string;
  number: string;
  profileType: ProfileType;
  profileId: string;
  productTemplate: {
    id: string;
    code: string;
    category: string;
  };
  productId: string;
  bankAccountId: string;
  currency: string;
  currentDay: string;
  balances: Balance[];
  status: 'ACTIVE' | 'BLOCKED' | 'CLOSED';
  alias?: string;
  name?: string;
  description?: string;
  type?: 'REGULAR' | 'META' | 'SETTLEMENT';
  glType?: GlType;
  regulatoryType?: RegulatoryType;
  branch?: string;
  created?: string;
  lastUpdated?: {
    lastUpdatedAt: string;
  };
};
